/*
 * @Descripttion: 整理逻辑,添加备注!!!
 * @version:
 * @Author: Duanshuai
 * @Date: 2022-01-21 15:56:06
 * @LastEditors: ------
 * @LastEditTime: 2022-02-28 10:01:28
 */
import request from "@/utils/request";

/**
 * 用户登录 POST
 */
export const login = (data) => {
    return request({
        method: "POST",
        url: "sales/newLogin",
        // data 用来设置 POST 请求体
        data,
    });
};
export const getCode = () => {
    return request({
        method: "GET",
        url: "sys/getCheckCode",
    });
};
// 退出登录
export const logout = () => { 
    return request({
        method: "GET",
        url: "sales/logout",
    });
};
//  获取验证码 接口 get
export const verifyCode = (params) => {
    return request({
        method: "GET",
        url: "/weixin/account/sendSmsCustom/"+params.mobile,
    });
};
//注册
export const register = (data) => {
    return request({
        method: "POST",
        url: "/sales/register",
        data,
    });
};
//验证手机号是否被注册
// sales/checkUserName/{userName}
export const checkUserName = (data) => {
    return request({
        method: "GET",
        url: "sales/checkUserName/"+data,
        
    });
};
//  客户管理列表
export const getCustomerList = (params) => {
    return request({
        method: "GET",
        url: "/sales/account/list",
        params,
    });
};

//操作--查看
export const getLookInfo = (params) => {
    return request({
        method: "GET",
        url: "/consumer/consumer/queryByAccountId",
        params,
    });
};

//操作--查看 - 所在城市
export const getLookInfoCity = (params) => {
    return request({
        method: "GET",
        url: "/location/divisions/queryByAccountId",
        params,
    });
};

//操作--访谈--列表
export const getTalkList = (params) => {
    return request({
        method: "GET",
        url: "/sales/account/interview/list",
        params,
    });
};

//操作--查看 - 亲属
export const getLookInfoClan = (params) => {
    return request({
        method: "GET",
        url: "/weixin/account/queryAccountFamilyMemberByMainId?_t=1627371396",
        params,
    });
};

///操作--查看 生成意向单
export const addInterview = (data) => {
    return request({
        method: "POST",
        url: "/sales/account/interview/add",
        data,
    });
};

//  创建客户信息
export const consumerInfo = (data) => {
    return request({
        method: "POST",
        url: "/consumer/consumer/add-account/",
        data,
    });
};

//操作--查看 - 合同列表
export const getClanInfoCon = (params) => {
    return request({
        method: "GET",
        url: "/order/order/listByAccountId",
        params,
    });
};
//操作--支付 - 支付列表
export const getPayList = (params) => {
    return request({
        method: "GET",
        url: "/order/pay/queryByAccountId",
        params,
    });
};
//操作--查看 - 合同详情
export const getClanDetail = (params) => {
    return request({
        method: "GET",
        url: "/order/order/" + params,
    });
};
//操作--支付--补录
export const PostPaySupplement = (data) => {
    return request({
        method: "POST",
        url: "/order/pay/detail/add",
        data,
    });
};

//操作--支付 - 支付二维码
export const PostPay = (data) => {
    return request({
        method: "POST",
        url: "/weixin/payparams/queryWxUrl",
        data,
        headers: {
            "Content-Type": "application/json",
        },
    });
};

//  根据所选城市 ID , 获取服务类型
export const getServeTypeCon = (params) => {
    return request({
        method: "GET",
        url: "/service/service/select-list",
        params,
    });
};

//  生成服务合同
export const postContract = (data) => {
    return request({
        method: "POST",
        url: "/order/order/unified-order",
        data,
    });
};
//  根据查询已有护理员,,来查找服务对象姓名
export const getServeName = (params) => {
    return request({
        method: "GET",
        url: "/weixin/account/queryFamilyMemberSelectList",
        params,
    });
};
//  可模糊查询已有护理员
export const getNurseFind = (params) => {
    return request({
        method: "GET",
        url: "/weixin/account/key-list",
        params,
    });
};
/**
 *   GET  获取护理员列表(包含个人信息)
 */
export const getNurseDetail = (params) => {
    return request({
        method: "GET",
        url: "/weixin/nurse/mp/list",
        params,
    });
};

//  护理员个人信息详情ID
export const getNurseDetailID = (params) => {
    return request({
        method: "GET",
        url: "/weixin/nurse/mp/queryById",
        params,
    });
};

//加载门店选择列表
export const getLoad = (params) => {
    return request({
        method: "GET",
        url: "/ajh/store/load-data",
        params,
    });
};

//我的意向单
export const selfList = (params) => {
    return request({
        method: "GET",
        url: "/sales/account/interview/selfList",
        params,
    });
};

//客户档案
export const myAccountlist = (params) => {
    return request({
        method: "GET",
        url: "/sales/account/interview/myAccountlist",
        params,
    });
};

//长护险护理员医保码绑定校验
export const checkBind = (params) => {
    return request({
        method: "GET",
        url: "/beacon/askLeave/checkBind",
        params,
    });
};

//长护险护理员医保码绑定
export const bindCode = (data) => {
    return request({
        method: "POST",
        url: "/beacon/askLeave/bindCode",
        data,
    });
};

//长护险护理员请假申请
export const apply = (data) => {
    return request({
        method: "POST",
        url: "/beacon/askLeave/apply",
        data,
    });
};

//客户档案编辑
export const consumerEdit = (data) => {
    return request({
        method: "put",
        url: "/consumer/consumer/edit",
        data,
    });
};

// 获取字典数据
export const getDictItems = (dictCode) => {
    return request({
        method: "GET",
        url: `/sys/dict/getDictItems/${dictCode}`,
    });
};
// 所属门店
export const loadData = (params) => {
    return request({
        method: "GET",
        url: "/ajh/store/load-data",
        params,
    });
};
// 护理员
export const nurseEmployeeStore = (storeId) => {
    return request({
        method: "GET",
        url: `/nurse/nurseEmployee/store/${storeId}`,
    });
};
// 督导员
export const storeUsers = (storeId) => {
    return request({
        method: "GET",
        url: `/sys/user/store-users/${storeId}`,
    });
};
// 护理产品类型
export const nurseType = (params) => {
    return request({
        method: "GET",
        url: "/sys/dict/getDictItems/nurse_type",
        params,
    });
};

//门店
export const loadSourceData = (params) => {
    return request({
        method: "GET",
        url: "/ajh/store/load-source-data/0",
        params,
    });
};

//七牛云服务器
export const imgUrl = (params) => {
    return request({
        method: "GET",
        url: "qiniu/token-url",
        params,
    });
};

//意向单
export const listNew = (params) => {
    return request({
        method: "GET",
        url: "sales/account/interview/listNew",
        params,
    });
};

// 长护险请假申请记录列表(GET)
export const myPageList = (params) => {
    return request({
        method: "GET",
        url: "/beacon/askLeave/myPageList",
        params,
    });
};

// 用印申请审批记录(GET)
export const getLeaveRecordDetail = (id) => {
    return request({
        method: "GET",
        url: `/beacon/askLeave/checkRecord/${id}`
    });
};

//我的意向单
export const salaryList = (params) => {
    return request({
        method: "GET",
        url: "/summary/salary/self-list",
        params,
    });
};